import React from 'react';
import {
    Grid,
    GridProps,
} from '@chakra-ui/react';
import { BlockHeader } from 'shared';
import { CompanyInformationModel, PopularServicesGroupModel } from 'entities';
import { Helmet } from 'react-helmet-async';
// eslint-disable-next-line no-restricted-imports
import { richTextToString } from 'shared/lib/richtext-to-string';
import { HomePageMainPopularServicesGroupSection } from './HomePageMainPopularServicesGroupSection';

export type HomePageMainProps = {
    popularServicesGroup?: PopularServicesGroupModel,
    companyInformation?: CompanyInformationModel,
} & GridProps & React.RefAttributes<HTMLDivElement>

export const HomePageMain: React.FC<HomePageMainProps> = ({
    popularServicesGroup,
    companyInformation,
    ...props
}) => (
    <Grid
        {...props}
    >
        <Helmet>
            <title>{companyInformation?.title}</title>
            <meta name="description" content={richTextToString(companyInformation?.description)} />
            <meta property="og:title" content={companyInformation?.title} />
        </Helmet>
        <BlockHeader
            title={companyInformation?.name || 'Кейтеринг в москве и области'}
            description={companyInformation?.description || []}
            imageSrc={companyInformation?.mainImage.url || ''}
        />
        <HomePageMainPopularServicesGroupSection
            catering={popularServicesGroup?.catering || undefined}
            delivery={popularServicesGroup?.delivery || undefined}
            culinaryStudio={popularServicesGroup?.culinaryStudio || undefined}
            outdoorBar={popularServicesGroup?.outdoorBar || undefined}
            sweetShop={popularServicesGroup?.sweetShop || undefined}
            padding="2rem"
            background="white"
            maxWidth={{
                base: '425px',
                lg: '1280px',
            }}
            width="100%"
            margin="0 auto"
        />
    </Grid>
);
